import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RamalEditarService {
  emissor = new EventEmitter<boolean>();
  ramalEditar: boolean = false;

  constructor() {}

  emitir(valor?: boolean) {
    if (valor !== null) {
      this.ramalEditar = valor;
    }
    this.emissor.emit(this.ramalEditar);
  }
}
